module.exports = __webpack_public_path__ + "static/img/theme6.2f1030e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/theme6.jpg
// module id = wb1N
// module chunks = 1